/**
 * Wave 3 — subtle TCP attribution.
 *
 * A quiet bottom-of-page brand mark designed so every screenshot of a
 * topic / entity / timeline page carries TCP attribution organically.
 *
 * This is distribution infrastructure, NOT DRM. We never block
 * screenshots. We just make sure the screenshot tells the world where
 * the investigation lives.
 *
 * Visual rule: small, low-contrast on screen, but visible enough to
 * land in any screenshot frame. The bigger emphasis in print/share
 * contexts so the mark survives compression and OCR-style consumption.
 */
import React from "react";
import { Link } from "react-router-dom";
import logoMark from "../assets/logo-tcp-mark.png";

const PUBLIC_SITE = (process.env.REACT_APP_PUBLIC_SITE_URL || "thecontextproject.com").replace(/^https?:\/\//, "");

export default function ShareAttribution({ slug, kind = "topic", className = "" }) {
    const path = slug ? `/${kind === "topic" ? "topic" : kind}/${slug}` : "";
    return (
        <div
            data-testid="share-attribution"
            className={`flex items-center justify-between gap-4 px-4 py-3 rounded-xl border border-[#243044] bg-[#0B1220]/60 ${className}`}
        >
            <Link to="/" className="flex items-center gap-2.5 group" aria-label="The Context Project">
                <div className="h-6 px-1.5 flex items-center justify-center rounded bg-white">
                    <img src={logoMark} alt="" className="h-3.5 w-auto select-none" draggable={false} />
                </div>
                <span className="text-[11px] uppercase tracking-[0.2em] text-[#64748B] group-hover:text-[#94A3B8] transition-colors font-medium">
                    The Context Project
                </span>
            </Link>
            <span
                className="text-[11px] text-[#64748B] font-mono truncate"
                title={`${PUBLIC_SITE}${path}`}
            >
                {PUBLIC_SITE}{path}
            </span>
        </div>
    );
}
